import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import _isFunction from "lodash/isFunction";
import React, { createContext, useContext, useMemo, useState, useEffect } from "react";
export var DEFAULT_API_URL = "https://api.runly.io";
var RunlyConfigContext = createContext();
export var Provider = function Provider(_ref) {
  var accessToken = _ref.accessToken,
      _ref$url = _ref.url,
      url = _ref$url === void 0 ? DEFAULT_API_URL : _ref$url,
      children = _ref.children;
  var value = useMemo(function () {
    return {
      accessToken: accessToken,
      url: url
    };
  }, [accessToken, url]);
  return /*#__PURE__*/React.createElement(RunlyConfigContext.Provider, {
    value: value
  }, children);
};
export var useConfig = function useConfig() {
  var cfg = useContext(RunlyConfigContext);

  var _useState = useState(),
      token = _useState[0],
      setToken = _useState[1];

  if (!cfg) {
    throw new Error("Missing Runly context. Make sure to include a RunlyProvider component up your component tree with your access token.");
  }

  var url = cfg.url,
      accessToken = cfg.accessToken; // accessToken could be a promise or a function

  useEffect(function () {
    var token = accessToken;

    if (token) {
      if (_isFunction(token)) {
        token = token();
      }

      if (token) {
        Promise.resolve(token).then(function (t) {
          return setToken(t);
        });
      }
    }
  }, [accessToken]);
  return {
    url: url,
    token: token
  };
};